export default function (userInfo) {
    var defaultOption = {
        user_id: userInfo.user_id || 0,
        account_id: userInfo.account_id || 0,
        role: userInfo.role || 'STUDENT',
        stage: userInfo.stage || 20,
        learning_version: userInfo.learning_version || 1,
        subject_id: userInfo.subject_id || 0,
        school_id: userInfo.school_id || 0,
        course_id: userInfo.course_id || 0,
        lesson_id: userInfo.lesson_id || 0,
        topic_id: userInfo.topic_id || 0,
        flow_id: userInfo.flow_id || 0,
        nick: userInfo.nick || '',
        app_type: userInfo.app_type || 1,
        client_ip: userInfo.client_ip || ''
    };
    var videoInfo = {
        video_type: userInfo.video_type || '',
        video_url: userInfo.video_url || '',
        video_id: userInfo.video_id || ''
    };
    if (userInfo.lmsVersion === 'vacation' || userInfo.lmsVersion === 'normalization' || userInfo.lmsVersion === 'v1' || userInfo.lmsVersion === 'v2') {
        videoInfo.lmsVersion = userInfo.lmsVersion;
    }
    if (userInfo.module_type) {
        videoInfo.module_type = userInfo.module_type || 0;
    }
    if (userInfo.module_name) {
        videoInfo.module_name = userInfo.module_name || '';
    }
    if (userInfo.submodule_type) {
        videoInfo.submodule_type = userInfo.submodule_type || 0;
        console.log({ videoInfo: videoInfo });
    }
    if (userInfo.submodule_name) {
        videoInfo.submodule_name = userInfo.submodule_name || '';
    }
    if (userInfo.tag_code) {
        videoInfo.tag_code = userInfo.tag_code || '';
    }
    videoInfo.tag_code_relearn_cnt = userInfo.tag_code_relearn_cnt || 0;
    if (userInfo.main_code) {
        videoInfo.main_code = userInfo.main_code || '';
    }
    if (userInfo.question_vno) {
        videoInfo.question_vno = userInfo.question_vno || 0;
    }
    if (userInfo.question_bank_version) {
        videoInfo.question_bank_version = userInfo.question_bank_version || '';
    }
    if (userInfo.question_title_id) {
        videoInfo.question_title_id = userInfo.question_title_id || '';
    }
    if (Array.isArray(userInfo.question_ids)) {
        videoInfo.question_ids = userInfo.question_ids;
    } else if (userInfo.question_ids) {
        videoInfo.question_ids = [userInfo.question_ids];
    } else {
        videoInfo.question_ids = [];
    }
    var options = Object.assign({}, defaultOption, videoInfo);
    return options;
};